/**
 * v-isAdmin 是否管理员
 * Copyright (c) 2019 ruoyi
 */

import useUserStore from '@/store/modules/user'

export default {
    mounted(el,binding, vnode) {
        const admin = "admin";
        const inner_admin = "inner";
        const roles = useUserStore().roles
        const isAdmin = !!roles.find(role => role === admin || role === inner_admin)
        if (!isAdmin) {
            el.parentNode && el.parentNode.removeChild(el)
        }
    }
}
